export const ADD_DRIVER_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  city: 'City',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  additionalDriver: {
    firstName: 'Additional Driver First Name',
    lastName: 'Additional Driver Last Name',
    dateOfBirth: 'Additional Driver Date Of Birth',
    maritalStatus: 'Additional Driver Marital Status',
    relationship: 'Additional Driver Relationship to the Policyholder',
    isInSameHousehold: 'Is Additional Driver Resides in same household?',
    streetAddress: 'Additional Driver Street Address',
    apt: 'Additional Driver Apartment#',
    city: 'Additional Driver City',
    state: 'Additional Driver State',
    zipCode: 'Additional Driver Zip Code',
    reason: "Please explan why Additional Driver doesn't have a valid license?",
    isLicenseValid: 'Does the Additional Driver have a valid license?',
    licenseNumber: "Additional Driver's License Number",
    effectDate: 'What date would you like this change to go into effect?'
  }
}
